import { DatastoreProvider, InstanceStack } from 'component/navigation/instance';
import { useInstanceConfig } from 'data/instance-config';
import { useLocalSearchParams } from 'expo-router';
import { SkeletonAdminScreen } from 'structure/admin/loading-screen';
import { adminModuleQuery } from 'system/structure-modules';

export function SuspenseFallback() {
    return <SkeletonAdminScreen />;
}

export default function AdminLayout() {
    const { siloKey } = useLocalSearchParams<'/[siloKey]/admin/one'>();
    const instanceConfig = useInstanceConfig({
        siloKey,
        structureKey: 'admin',
        instanceKey: 'one',
        moduleQuery: adminModuleQuery,
    });
    return (
        <DatastoreProvider {...instanceConfig}>
            <InstanceStack />
        </DatastoreProvider>
    );
}
